import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/api/global.service';
import { SearchComponent } from 'src/app/components/search/search.component';
import SwalAlert from 'src/app/utils/swalalert';
import AlertifyHelper from 'src/app/utils/utils';
import * as moment from 'moment';
import { ExpenseService } from 'src/app/api/money/expense.service';
import { OpeningService } from 'src/app/api/money/opening.service';
declare var $: any;

@Component({
  selector: 'app-historybox-list',
  templateUrl: './historybox-list.component.html',
  styleUrls: ['./historybox-list.component.css']
})
export class HistoryboxListComponent implements OnInit{
  private thisComponent: HistoryboxListComponent;
  branchofficeSlug = '';
  items: any = [];
  params: any = {
    search: ''
  };
  page = 1;
  count = 0;

  @ViewChild(SearchComponent) searchComponent: any;

  dataPagination: any = {
    pageSize: 0,
    currentPage: this.page,
    totalItems: 0
  };

  // variables
  start_range:any = moment().startOf('month');
  end_range:any = moment().endOf('month');

  constructor(
    private router: Router,
    private openingService: OpeningService,
    private globalService: GlobalService,
    private alert: SwalAlert,
    private alertifyMsg: AlertifyHelper,
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.thisComponent = this;
  }

  ngOnInit() {
    this.list();
  }

  list() {
    let val_params = 'search=' + this.params.search + '&page=' + this.page;
    this.openingService.listHistoryBox(val_params).subscribe({
      next: (data: any) => {
        this.items = data.results;
        this.dataPagination.pageSize = data.paginate_by;
        this.dataPagination.currentPage = this.page;
        this.dataPagination.totalItems = data.total;
      }
    });
  }

  search(text: any) {
    this.params.search = text;
    this.page = 1;
    this.list();
  }

  handlePageChange(event: any): void {
    this.page = event;
    this.list();
  }

  detail(id: number) {
    this.router.navigate([
      this.branchofficeSlug + '/caja/historialcaja/detalle',
      id
    ]);
  }

  refresh() {
    this.page = 1;
    this.params.search = '';
    // this.searchComponent.textSearch = '';
    this.list();
  }
}

